// Per-product size guide: if the product has inline `sizing.guide` content,
// populate the drawer from it and open without the theme's page fetch.
(() => {
  function handleClick(event) {
    const link = event.target.closest('[data-size-guide-link]');
    if (!link) return;

    const template = document.querySelector('template[data-size-guide-inline-source]');
    const drawer = document.querySelector('size-guide-drawer');
    if (!template || !drawer) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Inline content has no padding of its own, so apply the theme's standard
    // drawer-body padding. The fallback page brings its own spacing, so the body
    // is left unpadded there (this handler doesn't run on the fallback path).
    const body = drawer.querySelector('.global-drawer__body');
    if (body) body.classList.add('global-drawer__body--with-padding');

    const content = drawer.querySelector('[data-size-guide-content]');
    const heading = drawer.querySelector('[data-size-guide-dynamic-content="size-guide-header"] h3');

    if (heading) heading.textContent = link.textContent.trim();
    if (content) content.replaceChildren(template.content.cloneNode(true));

    window.eventBus.emit('open:size:guide', {});
  }

  document.addEventListener('click', handleClick, true);
})();
